import { tns } from 'tiny-slider/src/tiny-slider';

const container = document.querySelector('.ImageCarousel');

if (container) {
    const parent = container.parentNode;

    tns({
        container: container,
        items: 1,
        autoplay: true,
        slideBy: 'page',
        autoplayButtonOutput: false,
        mouseDrag: true,
        controlsContainer: parent.querySelector('.controls'),
        navContainer: '.tns-nav'
    });
}
